// The default number of guillotine cuts needed for one material sheet, derived from the solution's
// three sheet dimensions (exposed by QuoteBuilderParamsService#sheet_dimension_annotations) and the
// three "cut to size" checkboxes in the guillotine section. It is only the DEFAULT — the user can
// still edit the field. Version-2 (Manufacturing Cost Calculator) only.
//
// Each "cutting to size" step guillotines a bigger sheet down into a grid of smaller sheets:
//   - Pre-print cutting to size: the material sheet cut into printing sheets.
//   - Pre-die-cut cutting to size: the material sheet cut into die-cutting sheets.
// Dividing a sheet into an N-wide, M-tall grid takes (N-1) + (M-1) internal cuts. Squaring
// (trimming the sheet's four edges straight) is a flat 4 cuts.

// How many smaller sheets fit along one edge of the bigger sheet (floored). Zero when either size is
// missing or non-positive, so a missing dimension contributes no cuts rather than NaN/Infinity.
const sliceCount = (biggerMm, smallerMm) => {
  if (!(biggerMm > 0) || !(smallerMm > 0)) {
    return 0;
  }
  return Math.floor(biggerMm / smallerMm);
};

// Internal cuts to divide a sheet into countX-wide by countY-tall pieces. Never negative (a single
// piece along an axis needs no cut there).
const gridCuts = (countX, countY) => Math.max(0, countX - 1) + Math.max(0, countY - 1);

export function guillotineCutCountDefault(options, values) {
  const annotations = (options && options.sheet_dimension_annotations) || {};
  const material = annotations.material_sheet;
  const printing = annotations.printing_layout;
  const dieCutting = annotations.die_cutting_layout;
  const checkboxes = values || {};

  let cutCount = 0;

  if (checkboxes.pre_print_cutting_to_size === true && material && printing) {
    cutCount += gridCuts(
      sliceCount(material.width, printing.width),
      sliceCount(material.height, printing.height)
    );
  }

  if (checkboxes.pre_die_cut_cutting_to_size === true && material && dieCutting) {
    cutCount += gridCuts(
      sliceCount(material.width, dieCutting.width),
      sliceCount(material.height, dieCutting.height)
    );
  }

  if (checkboxes.squaring === true) {
    cutCount += 4;
  }

  return cutCount;
}
